import { render, staticRenderFns } from "./TermsOfService.vue?vue&type=template&id=cc5b275e&scoped=true"
import script from "./TermsOfService.vue?vue&type=script&lang=js"
export * from "./TermsOfService.vue?vue&type=script&lang=js"
import style0 from "./TermsOfService.vue?vue&type=style&index=0&id=cc5b275e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc5b275e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3254644805/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cc5b275e')) {
      api.createRecord('cc5b275e', component.options)
    } else {
      api.reload('cc5b275e', component.options)
    }
    module.hot.accept("./TermsOfService.vue?vue&type=template&id=cc5b275e&scoped=true", function () {
      api.rerender('cc5b275e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/TermsOfService.vue"
export default component.exports